module.exports = __webpack_public_path__ + "static/media/HCMM685.f3c02b71.jpg";